<template>
    <div>
        <div class="vrm-banners">
            <div v-if="showBannerToUser" id="twofactor-message-bar" class="vrm-sticky-bar info">
                <div class="alarm-content " @click="goToTwoFactorAuth">
                    <p>
                        {{
                            $t('twofactor.banner_message', {
                                i18nFallback:
                                    'To keep your account secure, we advise to enable 2FA on your account HERE.',
                            })
                        }}
                    </p>
                </div>
                <div class="alarm-cross" @click="dismissMessage">
                    <span class="sg-vrm-icon_055_cross-16px"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('twofactor')
@AngularDirective('vrm-two-fa-non-admin-banner')
export default class VrmTwoFaNonAdminBanner extends Vue {
    @ngInject()
    UserService;
    @ngInject()
    ApiService;
    @ngInject()
    $rootScope;

    hasTwoStepEnabled = false;
    isNonAdmin = true;
    hideBanner = false;
    loadingPreferences = true;

    async mounted() {
        await this.checkUserPreferences();
        await this.checkUser();
        //When 2FA is enabled, this event is broadcast. Adding a listener for it to instantly remove/show the banner
        window.addEventListener('user_state_changed', this.checkUser);
    }

    goToTwoFactorAuth() {
        this.$router.push('base.profile.twofactor');
    }

    beforeDestroy() {
        window.removeEventListener('user_state_changed', this.checkUser);
    }

    async dismissMessage() {
        this.hideBanner = true;
        try {
            // Send the preferences back to the server using PUT
            await this.ApiService.hideTwoFABanner();
        } catch (error) {
            //Do nothing
        }
    }

    async checkUserPreferences() {
        try {
            const preferences = await this.ApiService.getUserPreferences();
            this.hideBanner = preferences.hide2FABanner === 1;
        } catch (error) {
            this.hideBanner = true;
        } finally {
            // Set loading to false whether the API call succeeded or failed
            this.loadingPreferences = false;
        }
    }

    async checkUser() {
        try {
            const user = await this.UserService.getUser();
            this.isNonAdmin = user.accessLevel !== 2;
            this.hasTwoStepEnabled = user.twostepEnabled === true;
        } catch (error) {
            this.hideBanner = true;
        } finally {
            // Set loading to false whether the API call succeeded or failed
            this.loadingPreferences = false;
        }
    }

    get showBannerToUser() {
        const isOnTwoFactorPage = this.$route.path.includes('twofactor'); //Do not show the banner if user is already on twofactor page.
        return (
            !this.hideBanner &&
            this.isNonAdmin &&
            !this.hasTwoStepEnabled &&
            !this.loadingPreferences &&
            !isOnTwoFactorPage &&
            !this.$rootScope.userState.isDemo
        );
    }
}
</script>
